import type { z } from "zod";

import { zSchema } from "../../../../entity";

const zOutSchema = zSchema
  .omit({
    isApproved: true,
    orderNumber: true,
  })
  .extend({
    customer: zSchema.shape.customer.omit({
      email: true,
      phone: true,
    }),
  });
type OutSchema = z.infer<typeof zOutSchema>;

const zOutSchema2 = zSchema;
type OutSchema2 = z.infer<typeof zOutSchema2>;

export { zOutSchema, zOutSchema2 };
export type { OutSchema, OutSchema2 };
